// Mantis #1378/#1453 — M001-D029 §5 (F0307): the list of RealmAuthority-
// published groups for this organisation's one bound realm (cardinality
// 1:1, lead ruling) — name, description, grants summary, member count,
// publishedAt caption. Pure rendering + selection; no status text of its
// own. A group RealmAuthority never opted in does not exist here by
// construction (it was never published).
import React from 'react';
import GrantsSummary from './GrantsSummary';
import { formatDateTime } from './normalisers';
import './realmAuthority.css';

export default function RealmAuthorityGroupList({ groups = [], selectedGroupSid, onSelect }) {
  if (!groups.length) {
    return (
      <p className="ra-groups-none" data-testid="ra-groups-none">
        No groups are currently shared with StudioAEye. Groups are chosen in
        RealmAuthority's console.
      </p>
    );
  }
  return (
    <ul className="ra-group-list">
      {groups.map((group) => (
        <li key={group.groupSid}>
          <button
            type="button"
            className={`ra-group-item ${selectedGroupSid === group.groupSid ? 'ra-group-item--selected' : ''}`}
            aria-pressed={selectedGroupSid === group.groupSid}
            onClick={() => onSelect?.(group.groupSid)}
          >
            <span className="ra-group-name">{group.groupName}</span>
            {group.description ? <span className="ra-group-description">{group.description}</span> : null}
            <GrantsSummary grants={group.grants} />
            <span className="ra-group-meta">
              {group.members.length} member{group.members.length === 1 ? '' : 's'}
              {group.publishedAt ? ` · published ${formatDateTime(group.publishedAt)}` : ''}
              {group.pending?.length ? ` · ${group.pending.length} queued` : ''}
            </span>
          </button>
        </li>
      ))}
    </ul>
  );
}
